import { useLocation } from 'react-router-dom';

/**
 * Component hiển thị thông tin người dùng
 * Hiển thị các thông tin: tên đăng nhập, số điện thoại, email, ngân hàng, chi nhánh, số tài khoản
 */
function InfoUser() {
  const location = useLocation();
  const data = location.state?.data;
  
  return (
    <div className="w-full max-w-[640px] my-[15px] font-['Roboto',sans-serif] px-5 flex flex-col gap-3 ">
      <div className="flex justify-between">
        <span className="md:text-[14px] text-[12px] tracking-wide text-[#2F3945] font-medium">Tên đăng nhập</span>
        <span className="md:text-[14px] text-[12px] tracking-wide text-[#F27121] font-bold">{data?.Name || '-'}</span>
      </div>
      <div className="flex justify-between">
        <span className="md:text-[14px] text-[12px] tracking-wide text-[#2F3945] font-medium">Số điện thoại</span>
        <span className="md:text-[14px] text-[12px] tracking-wide text-[#F27121] font-bold">{data?.phone_number || '-'}</span>
      </div>
      <div className="flex justify-between">
        <span className="md:text-[14px] text-[12px] tracking-wide text-[#2F3945] font-medium">Gmail</span>
        <span className="md:text-[14px] text-[12px] tracking-wide text-[#F27121] font-bold">{data?.email || '-'}</span>
      </div>
      <div className="flex justify-between">
        <span className="md:text-[14px] text-[12px] tracking-wide text-[#2F3945] font-medium">Ngân hàng</span>
        <span className="md:text-[14px] text-[12px] tracking-wide text-[#F27121] font-bold">{data?.bank_name || '-'}</span>
      </div>
      <div className="flex justify-between">
        <span className="md:text-[14px] text-[12px] tracking-wide text-[#2F3945] font-medium">Chi nhánh</span>
        <span className="md:text-[14px] text-[12px] tracking-wide text-[#F27121] font-bold">{data?.Province || '-'}</span>
      </div>
      <div className="flex justify-between">
        <span className="md:text-[14px] text-[12px] tracking-wide text-[#2F3945] font-medium">Số tài khoản</span>
        <span className="md:text-[14px] text-[12px] tracking-wide text-[#F27121] font-bold">{data?.bank_number || '-'}</span>
      </div>
    </div>
  );
}

export default InfoUser;
